import React from "react";
import "../style/ProductCard.css";

const ProductCard = ({
  name,
  size,
  description,
  img,
  amazonLink,
  amazonDisabled,
  meeshoLink,
}) => {
  return (
    <article className="product-card">
      <div className="product-card-image-wrap">
        <img src={img} alt={name} className="product-card-image" />
      </div>
      <div className="product-card-title-row">
        <h3 className="product-card-name">{name}</h3>
        <span className="product-card-size">{size}</span>
      </div>
      <p className="product-card-description">{description}</p>
      <div className="product-card-actions">
        {amazonDisabled ? (
          <button
            type="button"
            className="btn btn-primary btn-disabled"
            disabled
            aria-disabled="true"
          >
            Coming Soon on Amazon
          </button>
        ) : (
          <a
            href={amazonLink || "#amazon-link"}
            target={amazonLink ? "_blank" : undefined}
            rel={amazonLink ? "noopener noreferrer" : undefined}
            className="btn btn-primary"
          >
            Buy on Amazon
          </a>
        )}
        <a
          href={meeshoLink || "#meesho-link"}
          target={meeshoLink ? "_blank" : undefined}
          rel={meeshoLink ? "noopener noreferrer" : undefined}
          className="btn btn-outline-cream"
        >
          Buy on Meesho
        </a>
      </div>
    </article>
  );
};

export default ProductCard;
